// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root___qJyt","label":"Category_label__K7mUC","content":"Category_content__18hhg","header":"Category_header__31_HW","location":"Category_location__2NMO9"};